import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import Microservice from "./router/Router";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloakConfig from "./services/authentication/Keycloak";
import { jwtReqInterceptor, jwtResInterceptor } from "./helpers/interceptor";
import "./localization/i18next";
import { Provider } from "react-redux";
import store from "./redux/store";
import { I18nextProvider } from "react-i18next";
import i18n from "./localization/i18next";
import { getMobileBootstrapInitOptions } from "./services/authentication/mobileBootstrap";
import detectMobilePhone from "./utils/detectMobilePhone";
import { addConsentV2Script } from "./helpers/initMenuOptions";
import { readImpersonationSession, restoreImpersonationSession, saveImpersonationTokens } from "./services/authentication/impersonationSession";

let options = { onLoad: "check-sso", checkLoginIframe: false };
if (detectMobilePhone) {
  options = { ...options, ...getMobileBootstrapInitOptions() };
}

const root = ReactDOM.createRoot(document.getElementById("root"));

const authentication = process.env.REACT_APP_AUTHENTICATION;

jwtReqInterceptor();
jwtResInterceptor();

setTimeout(() => {
  try {
    Promise.resolve(addConsentV2Script(i18n.language || store.getState().selectedLanguage)).catch(() => {});
  } catch (error) {
    console.warn("[consent] Cookie consent script could not be initialized", error);
  }
}, 0);

async function renderApplication() {
  try { await restoreImpersonationSession(); }
  catch (error) { console.error("[impersonation.session] Could not restore impersonation.", error); }
  const impersonation = readImpersonationSession();

  if (authentication == "ON") {
    const initOptions = impersonation ? { ...options, ...impersonation, onLoad: undefined, checkLoginIframe: false } : options;
    root.render(
      <ReactKeycloakProvider
        initOptions={initOptions}
        authClient={keycloakConfig}
        onTokens={saveImpersonationTokens}
        LoadingComponent={<div></div>}
      >
        <Provider store={store}>
          <BrowserRouter>
            <I18nextProvider i18n={i18n}>
              <Microservice />
            </I18nextProvider>
          </BrowserRouter>
        </Provider>
      </ReactKeycloakProvider>
    );
    return;
  }

  root.render(
    <Provider store={store}>
      <BrowserRouter>
        <I18nextProvider i18n={i18n}>
          <Microservice />
        </I18nextProvider>
      </BrowserRouter>
    </Provider>
  );
}

renderApplication();
